import React from 'react';
import { Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { RolesPermissionsContainer } from '@/components/admin/RolesPermissionsContainer';

/**
 * Step 3 — Roles & Permissions (TYPE B: Optional Configuration)
 *
 * Shows an informational state by default.
 * User clicks "Configure Roles Now" to expand the real settings page.
 */
interface StepRolesPermissionsProps {
  expanded: boolean;
  onExpand: () => void;
}

export const StepRolesPermissions: React.FC<StepRolesPermissionsProps> = ({
  expanded,
  onExpand,
}) => {
  if (expanded) {
    return (
      <div className="p-6 h-full">
        <div className="rounded-lg border border-border bg-white overflow-auto max-h-[calc(100vh-200px)]">
          <RolesPermissionsContainer />
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5">
          <Shield className="h-8 w-8 text-primary" />
        </div>

        {/* Heading */}
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Roles &amp; Permissions
        </h3>

        {/* Description */}
        <p className="text-sm text-muted-foreground leading-relaxed mb-6">
          Cash Forecaster comes with three default roles out of the box —{' '}
          <span className="font-medium text-foreground">User</span>,{' '}
          <span className="font-medium text-foreground">Administrator</span> and{' '}
          <span className="font-medium text-foreground">External User</span>. If
          your organisation needs custom roles, you can configure them here before
          assigning users in the next step. You can also do this later from{' '}
          <span className="font-medium text-foreground">
            Admin → Roles &amp; Permissions
          </span>
          .
        </p>

        {/* CTA */}
        <Button onClick={onExpand}>Configure Roles Now</Button>
      </div>
    </div>
  );
};
